import { useState, useMemo } from 'react';
import { List, useListContext, CreateButton, TopToolbar, useRedirect } from 'react-admin';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Chip } from '@mui/material';
import { tbl, btn, NAVY, fmtQty, PRODUCTION_BATCH_STATUS, clickableA11y } from '../styles/ds';
import { useFitCount } from '../hooks/useFitCount';
import FitPagination from '../components/FitPagination';

const fmtDate = iso => iso ? new Date(iso).toLocaleDateString('he-IL') : '—';
const fmtCost = v  => v != null ? `₪${Number(v).toLocaleString('he-IL',{minimumFractionDigits:0})}` : '—';

const Toolbar = () => (
  <TopToolbar><CreateButton label="מנת ייצור חדשה" sx={btn.create} /></TopToolbar>
);

const BatchTable = () => {
  const { data = [], isLoading } = useListContext();
  const redirect = useRedirect();
  const [page, setPage] = useState(1);
  const { fitCount, renderCount, containerRef, startIndex } = useFitCount({ fallback: 10, page });
  const pageItems = useMemo(() => {
    return data.slice(startIndex, startIndex + renderCount);
  }, [data, startIndex, renderCount]);

  if (isLoading) return null;

  return (
    <Box>
    <TableContainer component={Box} sx={{ ...tbl.container, border: '1px solid rgba(13,29,62,0.06)' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 60 }}>#</TableCell>
            <TableCell>מוצר מוגמר</TableCell>
            <TableCell align="center">כמות</TableCell>
            <TableCell align="right">עלות קנייה ליחידה</TableCell>
            <TableCell align="center">סטטוס</TableCell>
            <TableCell align="center">תאריך</TableCell>
          </TableRow>
        </TableHead>
        <TableBody ref={containerRef}>
          {pageItems.map((b, i) => {
            const st = PRODUCTION_BATCH_STATUS[b.status] || { label: b.status, bg: '#eee', color: '#555' };
            return (
              <TableRow key={b.id} onClick={() => redirect('show', 'production_batches', b.id)}
                {...clickableA11y(() => redirect('show', 'production_batches', b.id), { ariaLabel: `פתיחת מנת ייצור מספר ${b.id}` })}
                sx={tbl.bodyRow(i)}>
                <TableCell><Typography fontWeight={600} color="text.secondary" fontSize={13}>#{b.id}</Typography></TableCell>
                <TableCell><Typography fontWeight={600} fontSize={14}>{b.finished_name || `#${b.finished_variant_id}`}</Typography></TableCell>
                <TableCell align="center" sx={{ fontWeight: 600 }}>{fmtQty(b.quantity, b.unit)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: NAVY }}>{fmtCost(b.unit_cost_ils)}</TableCell>
                <TableCell align="center">
                  <Chip label={st.label} size="small" sx={{ backgroundColor: st.bg, color: st.color, fontWeight: 700, fontSize: 11 }} />
                </TableCell>
                <TableCell align="center" sx={{ fontSize: 12, color: 'text.secondary' }}>{fmtDate(b.confirmed_at || b.created_at)}</TableCell>
              </TableRow>
            );
          })}
          {data.length === 0 && (
            <TableRow><TableCell colSpan={6} align="center" sx={{ py: 6, color: 'text.secondary' }}>אין מנות ייצור</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    <FitPagination page={page} setPage={setPage} total={data.length} perPage={fitCount} />
    </Box>
  );
};

const ProductionList = () => (
  <List className="crm-mobile-list" sort={{ field: 'id', order: 'DESC' }} perPage={1000} pagination={false} storeKey={false} actions={<Toolbar />} title="ייצור" sx={tbl.listSx}>
    <BatchTable />
  </List>
);

export default ProductionList;
